import { MapPin, Clock, Phone, Car, TrainFront, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
export default function FindUs() {
  return <section data-section-id="136291" id="find-us-in-peliatan" className="bg-background text-foreground relative w-full min-h-[800px] md:min-h-[700px] flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/dark_grayscale_map_saffron_marker.png" alt="Map showing Ubud Event Space location" className="w-full h-full object-cover object-center opacity-80" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-transparent md:from-background/90 md:via-background/30"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 flex justify-start py-12">
        <Card className="w-full max-w-md bg-card/80 backdrop-blur-xl border-border/40 shadow-2xl font-sans">
          <CardHeader className="pb-6">
            <CardTitle className="text-3xl tracking-tight text-primary font-sans">Find Us in Peliatan</CardTitle>
            <CardDescription className="text-muted-foreground text-base font-sans mt-2">
              Conveniently located in the heart of Bali's cultural hub.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-8 font-sans">
            {}
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0">
                  <MapPin className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground text-xs uppercase tracking-widest mb-1">Address</p>
                  <p className="text-muted-foreground text-sm">Jalan Raya Peliatan, Ubud, Bali</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0">
                  <Clock className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground text-xs uppercase tracking-widest mb-1">Hours</p>
                  <p className="text-muted-foreground text-sm">Daily: 8:00 AM - 10:00 PM</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0">
                  <Phone className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground text-xs uppercase tracking-widest mb-1">Contact</p>
                  <p className="text-muted-foreground text-sm">+62 812 3456 789<br />events@ubudeventspace.com</p>
                </div>
              </div>
            </div>

            <div className="h-px w-full bg-border/50" />

            {}
            <div className="space-y-5">
               <div className="flex items-start gap-4">
                <div className="bg-muted/50 p-2 rounded-md shrink-0">
                  <Car className="w-5 h-5 text-muted-foreground" />
                </div>
                <div>
                  <p className="font-semibold text-foreground text-xs uppercase tracking-widest mb-1">Ample Parking</p>
                  <p className="text-muted-foreground text-sm leading-relaxed">Spacious on-site parking area accommodating multiple vehicles and motorbikes for your event guests.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-muted/50 p-2 rounded-md shrink-0">
                  <TrainFront className="w-5 h-5 text-muted-foreground" />
                </div>
                <div>
                  <p className="font-semibold text-foreground text-xs uppercase tracking-widest mb-1">Central Access</p>
                  <p className="text-muted-foreground text-sm leading-relaxed">Located along the main Peliatan road, offering easy access while maintaining a peaceful rice field backdrop.</p>
                </div>
              </div>
            </div>
          </CardContent>
          <CardFooter className="pt-4 pb-6">
            <Button className="w-full font-sans tracking-wide shadow-lg shadow-primary/20 bg-primary text-primary-foreground hover:bg-primary/90" size="lg" asChild>
              <Link to="https://maps.google.com/?q=Peliatan+Ubud+Bali" newTab>
                Get Directions <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}